import React, {useCallback, useState} from 'react';
import PropTypes from 'prop-types';
import {Icon} from '@/components/atoms';
import './SearchBar.scss';

/**
 * A reusable search bar component with customizable placeholder and search functionality.
 *
 * @component
 * @param {Object} props - Component props
 * @param {string} [props.placeholder='Search...'] - Placeholder text for the search input
 * @param {string} [props.className=''] - Additional CSS classes to apply to the container
 * @param {boolean} [props.useExternalSearch=false] - Whether to use external search (disables built-in filtering)
 * @param {Function} [props.onSearchChange] - Callback when search input changes (for external search)
 * @param {string} [props.initialValue=''] - Initial value for the search input
 */
const SearchBar = ({
  placeholder = 'Search...',
  className = '',
  onSearchChange = () => {},
  initialValue = ''
}) => {
  const [searchTerm, setSearchTerm] = useState(initialValue);

  const handleInputChange = useCallback(
    (e) => {
      const value = e.target.value;
      setSearchTerm(value);
      onSearchChange(value);
    },
    [onSearchChange]
  );

  return (
    <div className={`search-bar mb-4 ${className}`}>
      <input
        type='text'
        placeholder={placeholder}
        value={searchTerm}
        onChange={handleInputChange}
        className='px-3 pl-2 pr-10 text-sm text-white'
      />
      <Icon icon='search' className='search-icon text-gray-50' size='medium' />
    </div>
  );
};

SearchBar.propTypes = {
  placeholder: PropTypes.string,
  className: PropTypes.string,
  onSearchChange: PropTypes.func,
  initialValue: PropTypes.string
};

export default React.memo(SearchBar);
